import React, { useCallback, useEffect, useRef } from 'react';
import useMicrophone from 'hooks/voiceSearch';
import { trackVoiceSearch } from 'helpers/voiceSearch';
import { VoiceWrapperProps } from 'types/voiceSearch';
import View from './View';
import { VOICE_INACTIVITY } from 'constants/voiceSearch';


// 0 listening
// 1 voice session cut
// 2 user inactivity
// 3 audio end by api
// 4 other error

const VoiceWrapper = ({ handleVoiceSearch, handleClose }: VoiceWrapperProps) => {
  const textRef = useRef('');
  const startRecord = useRef(false);
  const { support, startListen, final, interim, stopListen, voiceStatus } = useMicrophone();
  const handleStart = useCallback(
    (clickFromHeader: boolean = false) => {
      startListen();
      startRecord.current = true;
      trackVoiceSearch(clickFromHeader);
    },
    [startListen]
  );
  const handleCross = () => {
    stopListen();
    startRecord.current = false;
    handleClose();
  };
  useEffect(() => {
    if (startRecord.current) {
      return;
    }
    handleStart(true);
  }, [handleStart, voiceStatus]);
  useEffect(() => {
    if ((voiceStatus === VOICE_INACTIVITY)) {
      setTimeout(() => {
        handleVoiceSearch(textRef.current);
      }, 50);
      return;
    }
  }, [handleVoiceSearch, voiceStatus]);
  if ((final || interim) && startRecord) {
    textRef.current = final + interim;
  }
  if (!support || voiceStatus < 0) {
    return null;
  }
  return (
    <View
      status={voiceStatus}
      voiceText={textRef.current}
      handleStart={handleStart}
      handleCross={handleCross}
    />
  );
};

export default VoiceWrapper;
